import { render, staticRenderFns } from "./PrintAttention.vue?vue&type=template&id=130c5258&scoped=true&"
import script from "./PrintAttention.vue?vue&type=script&lang=js&"
export * from "./PrintAttention.vue?vue&type=script&lang=js&"
import style0 from "./PrintAttention.vue?vue&type=style&index=0&id=130c5258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c5258",
  null
  
)

export default component.exports